import getSystemConfiguration from "./systemConfiguration";

export function getRegexRulesForField(fieldName) {
    let configuration = getSystemConfiguration()
    let filteredList = Object.entries(configuration)
        .filter(key => key.toString().toLowerCase().startsWith(fieldName + "pattern"));
    return filteredList
}